'use client';
import Box from '@mui/material/Box';
import {styled} from '@mui/material/styles';
import type {NavLink} from '@olympus-frontend/tenant-config';
import {Typography} from '../primitives';
import {FooterNavLink} from './FooterNavLink';
import {ColumnLinks} from './styles';

interface FooterBottomBarProps {
  copyright: string;
  legalLinks: NavLink[];
}

const BottomRow = styled(Box)(({theme}) => ({
  paddingTop: theme.spacing(2),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  [theme.breakpoints.up('md')]: {
    borderTop: `1px solid ${theme.palette.colors.border.neutral.inverse}`,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: theme.spacing(6),
    paddingTop: theme.spacing(4),
  },
}));

export function FooterBottomBar({copyright, legalLinks}: FooterBottomBarProps) {
  return (
    <BottomRow>
      <Typography size="body-2" weight="regular" sx={{color: theme => theme.palette.colors.text.neutral.inverseMuted}}>
        {copyright}
      </Typography>
      {legalLinks.length > 0 && (
        <ColumnLinks component="ul" direction="row">
          {legalLinks.map(legalLink => (
            <FooterNavLink key={legalLink.key} item={legalLink} size="sm" />
          ))}
        </ColumnLinks>
      )}
    </BottomRow>
  );
}

FooterBottomBar.displayName = 'FooterBottomBar';
